/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const contactValueLabelDtoSchema = z.object({
    "value": z.string(),
"label": z.optional(z.string())
    })